/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import { IAddHouseHoldOrderTypes, IInvoice } from "shared/interface/types";

const initialState: { HouseHoldOrder: IAddHouseHoldOrderTypes; Invoice: IInvoice } = {
  HouseHoldOrder: {
    id: "",
    customerDetailId: "",
    name: "",
    houseHoldPlanId: null,
    planName: "",
    productName: "",
    cartId: "",
    lineOfBussiness: {
      id: null,
      name: ""
    },
    takafulProvider: {
      id: "",
      companyName: ""
    },
    paymentFrequency: {
      id: null,
      name: ""
    },
    planType: {
      id: null,
      name: ""
    }
  },
  Invoice: {
    id: "",
    dueDate: "",
    amount: "",
    currencySymbol: "",
    paidAt: "",
    currencyId: 0,
    tax: "",
    createdById: "",
    updatedById: "",
    createdAt: "",
    updatedAt: "",
    activityFkId: "",
    payerUserId: "",
    paymentStatusId: 0,
    pickupAddress: "",
    activity: {
      id: 0,
      value: ""
    },
    type: {
      id: 0,
      value: ""
    },
    paymentStatus: {
      id: 0,
      key: "",
      value: ""
    },
    paymentMode: {
      id: 0,
      value: ""
    },
    paymentMethod: {
      id: 0,
      value: ""
    },
    currency: {
      id: 0,
      name: "",
      code: "",
      symbol: ""
    },
    totalContributionValue: "",
    amountValue: "",
    updatedBy: {
      id: 0,
      name: ""
    },
    payer: {
      id: "",
      contactNumber: "",
      name: "",
      isActive: true,
      email: "",
      profileImage: "",
      userType: {
        id: 0,
        key: ""
      }
    }
  }
};

const houseHoldOrderSlice = createSlice({
  name: "houseHoldOrder",
  initialState,
  reducers: {
    AddHouseHoldOrder: (state, action) => {
      state.HouseHoldOrder = action.payload;
    },
    AddOrderInvoice: (state, action) => {
      state.Invoice = action.payload;
    },
    DeleteHouseHoldOrder: state => {
      state.HouseHoldOrder = initialState.HouseHoldOrder;
    }
  }
});

export const { AddHouseHoldOrder, AddOrderInvoice, DeleteHouseHoldOrder } = houseHoldOrderSlice.actions;
export default houseHoldOrderSlice.reducer;

export const getHouseHoldOrder = (state: RootState) => state.houseHoldOrder;
export const getInvoice = (state: RootState) => state.houseHoldOrder;
